import {groq} from 'next-sanity';

import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import {DOCUMENT_TYPE_ARTICLE} from '../constants';
import type {ArticleSchema} from '../schema';

export const ARTICLE_FRAGMENT = groq`
	...,
	lead[] {
		${PORTABLE_TEXT_FRAGMENT}
	},
	content[] {
		${PORTABLE_TEXT_FRAGMENT}
	}
`;

// TODO: This should have the resolved portable text field type:
export type ArticleFragment = ArticleSchema;

/**
 * Fetches the current article
 */

export const ARTICLE_BY_SLUG_QUERY = groq`
*[_type == "${DOCUMENT_TYPE_ARTICLE}" && slug.current == $slug][0] {
	${ARTICLE_FRAGMENT}
}
`;

export type ArticleBySlugQueryResult = ArticleFragment | null;
